import { Field } from "../config/companies/config";

const MAX_ROW_FLEX = 1;
const ROW_FLEX_EPSILON = 0.0001;

export const shouldHideDisplayValue = (
  field: Field | undefined,
  value: unknown,
  userRole: string,
) => {
  if (!field) {
    return false;
  }

  const roleHiddenValues = field.hideWhenValueInDisplayByRole?.[userRole] ?? [];
  return [...(field.hideWhenValueInDisplay ?? []), ...roleHiddenValues]
    .map((hiddenValue) => String(hiddenValue))
    .includes(String(value));
};

export const calculateDisplayRows = <T extends { flex?: number }>(
  items: T[],
): (T & { flex: number })[][] => {
  if (!items.length) {
    return [];
  }

  const rows: (T & { flex: number })[][] = [];
  let currentRow: (T & { flex: number })[] = [];
  let currentRowFlex = 0;

  for (const item of items) {
    const flex =
      typeof item.flex !== "number" ||
      !Number.isFinite(item.flex) ||
      item.flex <= 0
        ? MAX_ROW_FLEX
        : Math.min(item.flex, MAX_ROW_FLEX);
    const normalizedItem = { ...item, flex };

    if (
      currentRow.length > 0 &&
      currentRowFlex + flex > MAX_ROW_FLEX + ROW_FLEX_EPSILON
    ) {
      rows.push(currentRow);
      currentRow = [];
      currentRowFlex = 0;
    }

    currentRow.push(normalizedItem);
    currentRowFlex += flex;
  }

  if (currentRow.length > 0) {
    rows.push(currentRow);
  }

  return rows;
};
